import React, { lazy, Suspense } from 'react';
import { useSearchParams } from 'react-router-dom';
import ReviewPage from '../components/ReviewPage';
import { isSmartCard } from './model';

const PublicProfile = lazy(() => import('./PublicProfile'));

export default function ScanRouter() {
  const [search] = useSearchParams();
  if (!isSmartCard(search.get('id'), search.get('t'))) return <ReviewPage />;
  return <Suspense fallback={<p role="status">Loading page…</p>}><PublicProfile scanned /></Suspense>;
}
